/**
 * InterviewQuestionsModal — "Manage Questions" entry point for the
 * pipeline's AI Interview stage. Unlike the mcq/coding/both stage
 * (AssessmentManagerModal.jsx), no separate assessment job needs to be
 * provisioned here: interview questions already live directly on the
 * pipeline job doc itself (uploadedQuestions + config.role/jd_text), since
 * the pipeline job's own eventType is always "INTERVIEW" — the same
 * eventType this question bank already expects. So this just opens the
 * existing, unmodified QuestionBankManager UI pointed at the pipeline job
 * id directly.
 */
import React from "react";
import QuestionBankManager from "./QuestionBankManager";
import { jdTextFromCriteria } from "./AssessmentManagerModal";
import "./RecruiterJobs.css";
import "./QuestionBankManager.css";

export default function InterviewQuestionsModal({ open, jobId, companyName, jobTitle, resumeCriteria, onClose }) {
  if (!open) return null;

  return (
    <div className="recruiter-modal-backdrop" role="presentation" onClick={onClose}>
      <div className="recruiter-modal recruiter-modal--wide" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="recruiter-modal-header">
          <div>
            <h2>{jobTitle || "Interview"} — Questions</h2>
            <p>AI Interview round for this pipeline</p>
          </div>
          <button className="icon-button" type="button" onClick={onClose} aria-label="Close">x</button>
        </div>
        <QuestionBankManager
          jobId={jobId}
          eventType="INTERVIEW"
          companyName={companyName}
          onClose={onClose}
          initialRole={resumeCriteria?.job_title || jobTitle || ""}
          initialJdText={jdTextFromCriteria(resumeCriteria)}
        />
      </div>
    </div>
  );
}
